import { fontsV2 } from 'shared/constants/menu-fonts';
import { FontOption } from './fonts.types';

export const fonts: Array<FontOption> = Object.values(fontsV2);
export const nonLocalFonts: Array<FontOption> = fonts.filter((font) => !font.localFont);
